// frontend/src/components/aria/AriaButton.js
import { useAriaContext } from '../../contexts/AriaContext';

const S = {
  btn: (active) => ({
    position: 'fixed', bottom: 24, right: 24, zIndex: 900,
    width: 40, height: 40,
    background: active ? 'hsl(75,100%,45%)' : 'hsl(75,100%,50%)',
    color: '#000',
    border: 'none', cursor: 'pointer',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontSize: 18, fontWeight: 700,
    boxShadow: active
      ? '0 0 0 3px rgba(117,255,0,0.27), 0 0 24px rgba(117,255,0,0.4)'
      : '0 0 16px rgba(117,255,0,0.2)',
    transition: 'box-shadow 0.2s, background 0.2s',
    fontFamily: "'JetBrains Mono', monospace",
  }),
  label: {
    position: 'fixed', bottom: 70, right: 24, zIndex: 900,
    fontFamily: "'JetBrains Mono', monospace", fontSize: 8,
    color: 'hsl(0,0%,40%)', textTransform: 'uppercase', letterSpacing: '0.1em',
    pointerEvents: 'none',
  },
};

export default function AriaButton() {
  const { isOpen, togglePanel } = useAriaContext();
  if (isOpen) return null;
  return (
    <>
      <button
        data-testid="aria-floating-btn"
        style={S.btn(false)}
        onClick={togglePanel}
        title="ARIA AI (⌘K)"
      >
        ✦
      </button>
      <div style={S.label}>⌘K</div>
    </>
  );
}
